module.exports = __webpack_public_path__ + "img/Touryak.38f1dc26.jpg";